import idsEqual from './idsEqual';

/** Events the bell still shows to the person who triggered them. */
export const INITIATOR_VISIBLE_TYPES = [
  'asset.adobe_uploaded',
  'inbox.asset.created',
  'inbox.assetsLimitExceeded',
  'sync.succeed.FullSync',
  'asset.transcribing.complete',
  'asset.videoAnalyzing.complete',
  'asset.videoAnalyzing.failed',
  'request.created',
];

export default function isOwnNotificationHidden(event, userId) {
  if (!event || !event.initiator || event.initiator._id == null || userId == null) {
    return false;
  }
  if (!idsEqual(event.initiator._id, userId)) {
    return false;
  }
  return !INITIATOR_VISIBLE_TYPES.includes(event.type);
}
